import { render, staticRenderFns } from "./fab.vue?vue&type=template&id=9b6f1768"
import script from "./fab.vue?vue&type=script&lang=ts"
export * from "./fab.vue?vue&type=script&lang=ts"
import style0 from "./fab.vue?vue&type=style&index=0&id=9b6f1768&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports